import { Check } from 'lucide-react';
import { DropdownMenu as D } from 'radix-ui';
import * as React from 'react';
import { cn } from '../utils';

export const DropdownMenu = D.Root;
export const DropdownMenuTrigger = D.Trigger;
export const DropdownMenuRadioGroup = D.RadioGroup;

const contentCls =
  'z-50 min-w-44 rounded-md border border-border bg-popover p-1 text-sm shadow-lg outline-none data-[state=open]:animate-in';
const itemCls =
  'flex cursor-pointer select-none items-center gap-2 rounded px-2 py-1.5 text-sm outline-none data-[highlighted]:bg-muted data-[disabled]:pointer-events-none data-[disabled]:opacity-50';

export function DropdownMenuContent({
  className,
  align = 'start',
  ...props
}: React.ComponentProps<typeof D.Content>) {
  return (
    <D.Portal>
      <D.Content
        align={align}
        sideOffset={6}
        collisionPadding={8}
        className={cn(contentCls, className)}
        {...props}
      />
    </D.Portal>
  );
}

export function DropdownMenuLabel({ className, ...props }: React.ComponentProps<typeof D.Label>) {
  return (
    <D.Label
      className={cn(
        'px-2 py-1 text-[11px] uppercase tracking-wide text-muted-foreground',
        className,
      )}
      {...props}
    />
  );
}

export function DropdownMenuRadioItem({
  className,
  children,
  ...props
}: React.ComponentProps<typeof D.RadioItem>) {
  return (
    <D.RadioItem className={cn(itemCls, 'pl-7', className)} {...props}>
      <D.ItemIndicator className="absolute left-2">
        <Check className="size-3.5 text-accent" />
      </D.ItemIndicator>
      <span className="relative">{children}</span>
    </D.RadioItem>
  );
}

export function DropdownMenuItem({ className, ...props }: React.ComponentProps<typeof D.Item>) {
  return <D.Item className={cn(itemCls, className)} {...props} />;
}

export function DropdownMenuSeparator(props: React.ComponentProps<typeof D.Separator>) {
  return <D.Separator className="-mx-1 my-1 h-px bg-border" {...props} />;
}
